export default "__VITE_ASSET__BuJPsM_n__"